import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createOptionGroup } from '../../api/apiOptionGroups';
import { toast } from 'react-hot-toast';
import parseError from '../../utils/parseError';

/**
 * Hook to create a new option group
 */
export const useCreateOptionGroup = () => {
    const queryClient = useQueryClient();

    const { mutate: createOptionGroupMutate, isPending: isCreating } = useMutation({
        mutationFn: createOptionGroup,
        onSuccess: (res) => {
            queryClient.invalidateQueries({ queryKey: ['optionGroups'] });
            toast.success(res?.data?.message);
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message);
        }
    });

    return { createOptionGroupMutate, isCreating };
};
